// Central business identity + legal page registry. Placeholder contact values —
// replace with real details (and keep them consistent with the App Store listing).
export const BUSINESS = {
  legalName: 'The Tiffin by The Virsa',
  brand: 'The Tiffin',
  city: 'Edmonton, AB, Canada',
  region: 'Alberta, Canada',
  address: '9516 Ellerslie Road SW, Edmonton, AB T6X 0K6',
  phone: '(780) 909-0988',
  email: 'Thetiffinyeg@gmail.com',
  supportEmail: 'Thetiffinyeg@gmail.com',
  hours: 'Mon – Sat · 11:00 AM – 8:00 PM',
};

export const EFFECTIVE_DATE = 'June 2026';

export const LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms of Service' },
  { to: '/allergy', label: 'Allergy Policy' },
  { to: '/refunds', label: 'Refund & Cancellation' },
  { to: '/payment-terms', label: 'Payment & Subscription' },
  { to: '/support', label: 'Support' },
  { to: '/delete-account', label: 'Delete My Account' },
  { to: '/about', label: 'About Us' },
];


// Shown in the checkout allergy popup and on the /allergy page. Keep both in sync via this source.
export const ALLERGY_NOTE = [
  'All of our food is prepared and packed in a single shared kitchen that handles many ingredients — including common allergens such as milk, tree nuts, peanuts, wheat/gluten, soy, mustard, and sesame.',
  'Because everything is made in the same space, we cannot guarantee that any dish is free from traces of these allergens. There is a real risk of cross-contamination.',
  'If you have any food allergy or intolerance, The Tiffin does not recommend eating food prepared at our location. Please make your own informed decision — by continuing, you understand and accept this risk.',
];

// Short plain-language summary shown in the checkout Terms popup (full text lives on /terms).
export const TERMS_SUMMARY = [
  'Your subscription is a prepaid package of tiffins valid for a set number of days — it does not auto-renew.',
  'Payments are processed by Square; plans activate once payment is confirmed. Refunds follow our Refund & Cancellation Policy.',
  'Use your account and QR pass responsibly. Misuse or non-payment may lead to suspension.',
];
